
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_1mfbn_mzybe_149",
  "grid-cell": "awsui_grid-cell_1mfbn_mzybe_154",
  "day-header": "awsui_day-header_1mfbn_mzybe_161",
  "day": "awsui_day_1mfbn_mzybe_161",
  "month": "awsui_month_1mfbn_mzybe_172",
  "day-inner": "awsui_day-inner_1mfbn_mzybe_220",
  "month-inner": "awsui_month-inner_1mfbn_mzybe_221",
  "in-first-row": "awsui_in-first-row_1mfbn_mzybe_228",
  "in-previous-month": "awsui_in-previous-month_1mfbn_mzybe_228",
  "in-previous-year": "awsui_in-previous-year_1mfbn_mzybe_229",
  "last-day-of-month": "awsui_last-day-of-month_1mfbn_mzybe_233",
  "last-month-of-year": "awsui_last-month-of-year_1mfbn_mzybe_234",
  "in-next-month": "awsui_in-next-month_1mfbn_mzybe_238",
  "in-next-year": "awsui_in-next-year_1mfbn_mzybe_239",
  "in-first-column": "awsui_in-first-column_1mfbn_mzybe_243",
  "in-visible-calendar": "awsui_in-visible-calendar_1mfbn_mzybe_246",
  "in-current-month": "awsui_in-current-month_1mfbn_mzybe_246",
  "in-current-year": "awsui_in-current-year_1mfbn_mzybe_246",
  "enabled": "awsui_enabled_1mfbn_mzybe_250",
  "in-range": "awsui_in-range_1mfbn_mzybe_256",
  "end-date": "awsui_end-date_1mfbn_mzybe_256",
  "start-date": "awsui_start-date_1mfbn_mzybe_256",
  "no-range": "awsui_no-range_1mfbn_mzybe_256",
  "selected": "awsui_selected_1mfbn_mzybe_266",
  "today": "awsui_today_1mfbn_mzybe_271",
  "this-month": "awsui_this-month_1mfbn_mzybe_272",
  "in-range-border-block-start": "awsui_in-range-border-block-start_1mfbn_mzybe_328",
  "in-range-border-inline-end": "awsui_in-range-border-inline-end_1mfbn_mzybe_331",
  "in-range-border-block-end": "awsui_in-range-border-block-end_1mfbn_mzybe_334",
  "in-range-border-inline-start": "awsui_in-range-border-inline-start_1mfbn_mzybe_337"
};
  